import Ship from './ship';

class Destroyer extends Ship {
  constructor() {
    super(3);
  }
}

export default Destroyer;
